import { useQuery } from '@tanstack/react-query';

import { venueGetUserPictureApi } from '../../api/users/venueGetUserPictureApi';
import { User } from '../../graphql/API';

export const useQueryUserPicture = (
  venueId: string | undefined,
  userId: string | number | undefined,
) => {
  return useQuery<User | null>({
    queryKey: ['user-picture', venueId, userId ? String(userId) : undefined],
    queryFn: async () => {
      try {
        return await venueGetUserPictureApi({
          venueID: Number(venueId),
          userID: Number(userId),
          checkHasEventReservation: false,
        });
      } catch (err) {
        // Some users (e.g. incentive recipients without a reservation at this
        // venue) may not be resolvable via venueGetUser. Swallow the error so
        // we can fall back to initials without breaking the table row.
        return null;
      }
    },
    enabled: Boolean(venueId) && Boolean(userId),
    staleTime: 5 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
